import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import VerificationModal from "./VerificationModal";
import {
  fetchData,
  fetchSettlement,
  fetchSubwalletDropdown,
  clearAccountData,
} from "../../../features/fetch/fetchSlice";
import { setActiveObj, setWalletObj } from "../../../features/obj/objSlice";
import { walletTransferType } from "../../../data";

const { TextArea } = Input;

const TransferModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const urlAccount = "api/v1/wallet/search";
  const { loading, dataAccount } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataAccount: state.fetch.data[urlAccount] || [],
  }));
  const [hasSearched, setHasSearched] = useState(false);

  const { subwalletData, settlement, dropLoading } = useSelector(
    (state) => state.fetch
  );
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const { singlePaymentObj } = useSelector((state) => state.obj);
  const [paymentSourceName, setPaymentSourceName] = useState();
  const [benefitiaryName, setBenefitiaryName] = useState();

  const [selectedSourceWallet, setSelectedSourceWallet] = useState(null);
  const [transferType, setTransferType] = useState();

  const handleTransferType = async (value) => {
    await setTransferType(value);
    await form.setFieldsValue({ targetWallet: "", targetWallet: "" });
    dispatch(clearAccountData());
    setHasSearched(false);
  };

  const [openVerification, setopenVerification] = useState(false);
  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  const [selectedWallet, setSelectedWallet] = useState(null);
  const [enteredAmount, setEnteredAmount] = useState(null);

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setShow();
    await setEnteredAmount(null);
    await setSelectedWallet(null);
    await dispatch(clearAccountData());
    form.setFieldsValue({ targetWallet: null});
    setHasSearched(false);
  }

  const [formData, setFormData] = useState();
  const [show, setShow] = useState(singlePaymentObj?.paymentMethod);

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const onFinish = async (data) => {
    data.pyType = "MPESA";
    data.paymentSourceName = paymentSourceName;
    data.benefitiaryName = benefitiaryName;
    await dispatch(setActiveObj(data));
    await handleOpenVerification();
  };

  const handleViewWallet = async (item) => {
    await dispatch(setWalletObj(item));
    await navigate("/my-wallet-view");
  };

  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }

  async function fetchAccountData(item) {
    setHasSearched(true);
    dispatch(
      fetchData({
        url: urlAccount,
        search: item,
      })
    );
  }

  useEffect(() => {
    if (dataAccount?.[0]?.walName && transferType === "ACCOUNT") {
      setBenefitiaryName(dataAccount[0].walName);
      form.setFieldsValue({ targetWallet: dataAccount[0].walId });
    }
  }, [dataAccount, transferType, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Funds Transfer`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
            <Form.Item
              name="sourceWallet"
              className=""
              label={<span>Payment Source</span>}
              rules={[
                {
                  required: true,
                  message: "Please select payment source",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  subwalletData?.length > 0 &&
                  subwalletData?.map((item) => ({
                    value: item?.walId,
                    label:
                      item?.walName +
                      " - " +
                      item?.walCode +
                      " - " +
                      item?.walCurrency +
                      " " +
                      item?.walAvailableBalance,
                  }))
                }
                onChange={(value) => {
                  const selectedItem = subwalletData?.find(
                    (item) => item?.walId === value
                  );
                  setSelectedWallet(selectedItem || null);
                  setEnteredAmount(null);
                  setPaymentSourceName(selectedItem?.walName || "");
                  setSelectedSourceWallet(value);
                  form.resetFields(["targetWallet"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchSubWalletData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {dropLoading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              name="type"
              className=""
              label={<span>Transfer Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select transfer type",
                },
                1,
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  walletTransferType?.length > 0 &&
                  walletTransferType?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleTransferType(value);
                  form.resetFields(["targetWallet"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </Form.Item>
            {transferType === "WALLET" ? (
              <Form.Item
                name="targetWallet"
                className=""
                label={<span>Wallet Account</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select Wallet Account",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={subwalletData
                    ?.filter((item) => item?.walId !== selectedSourceWallet)
                    ?.map((item) => ({
                      value: item?.walId,
                      label: `${item?.walName} - ${item?.walCurrency} ${item?.walAvailableBalance}`,
                    }))}
                  onChange={(value) => {
                    const selectedItem = subwalletData?.find(
                      (item) => item?.walId === value
                    );
                    setBenefitiaryName(selectedItem?.walName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  onDropdownVisibleChange={() => {
                    fetchSubWalletData();
                  }}
                />
              </Form.Item>
            ) : transferType === "SETTLE" ? (
              <Form.Item
                name="targetWallet"
                className=""
                label={<span>Settlement Account</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select Settlement Account",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    settlement?.length > 0 &&
                    settlement?.map((item) => ({
                      value: item?.settlementId,
                      label: item?.settlementName,
                    }))
                  }
                  onChange={(value) => {
                    const selectedItem = settlement?.find(
                      (item) => item?.settlementId === value
                    );
                    setBenefitiaryName(selectedItem?.settlementName || "");
                  }}
                  // onChange={(value) => {
                  //   setTransferType(value);
                  // }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            ) : transferType === "ACCOUNT" ? (
              <div>
                <div className="mb-2">
                  <label className="ant-form-item-label">
                    <span>Account</span>
                  </label>
                  <Input
                    className="input"
                    placeholder="Enter account code in full"
                    onBlur={(e) => {
                      const value = e.target.value;
                      if (value) {
                        fetchAccountData(value);
                      }
                    }}
                    onChange={() => {
                      dispatch(clearAccountData());
                      setBenefitiaryName("");
                      form.setFieldsValue({ targetWallet: undefined });
                      setHasSearched(false);
                    }}
                  />
                  {loading && (
                    <div className="mb-3 text-center mt-2">
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {!loading && hasSearched && dataAccount?.length === 0 && (
                    <span className="text-sm font-medium text-[#FF0000]">
                      No account found
                    </span>
                  )}
                  {!loading && dataAccount?.[0]?.walName && (
                    <span className="text-sm font-medium text-[#008000]">
                      Account: {dataAccount[0].walName}
                    </span>
                  )}
                </div>
                <Form.Item
                  name="targetWallet"
                  className="hidden"
                  rules={[
                    {
                      required: true,
                      message: "Please search and select an account",
                    },
                  ]}
                >
                  <Input type="hidden" />
                </Form.Item>
              </div>
            ) : null}

            <Form.Item
              extra={
                selectedWallet &&
                enteredAmount &&
                Number(selectedWallet?.walAvailableBalance) <
                  Number(enteredAmount) && (
                  <div className="text-[#2563EB] text-[.85rem] font-[400] leading-[1.5rem] gap-[.3rem]  flex items-center">
                    {selectedWallet?.walType === "DISBURSEMENT"
                      ? "Insufficient funds please top up collection wallet first."
                      : selectedWallet?.walType === "COLLECTION"
                      ? "Insufficient funds please top up to proceed."
                      : null}
                    <span
                      className="text-[#1F54C8] text-[.85rem] font-[500] cursor-pointer"
                      onClick={() =>
                        selectedWallet?.walType === "COLLECTION"
                          ? handleViewWallet(selectedWallet)
                          : null
                      }
                    >
                      {selectedWallet?.walType === "COLLECTION"
                        ? "+Top Up Amount"
                        : null}
                    </span>
                  </div>
                )
              }
              name="amount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Enter amount",
                },
              ]}
            >
              <InputNumber
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter amount"
                className="input flex"
                onChange={(value) => setEnteredAmount(value)}
              />
            </Form.Item>
          </div>

          <Form.Item
            className="mt-5"
            name="reason"
            label="Reason for transfer"
            rules={[
              {
                required: true,
                message: "Enter reason for transfer",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter reason for transfer"
              className="input-textarea "
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className={`cstm-btn-2 ${
                    Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount) && "!cursor-not-allowed"
                  }`}
                  disabled={
                    saving ||
                    Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount)
                  }
                >
                  {saving ? <Spin /> : "Next"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <VerificationModal
        handleFetchData={handleFetchData}
        open={openVerification}
        setopenVerification={setopenVerification}
        handleCancel={handleCancelVerification}
        handleCancelSingle={handleCancel}
      />
    </>
  );
};
export default TransferModal;
